<button pButton class="btn btn-sm btn-outline-primary" *ngIf="!fromEContract" (click)="downloadReport()"><i class="fas fa-download mr-1"></i>Download Report</button>

<div id="pdfContent" style="padding: 10px;" class="mt-3">
    <h3 style="text-align: center; font-weight: bold;">
       <u> <span>{{evaluationHeading}} EVALUATION REPORT</span>  <br/>
</u>
    </h3>
    <div style="margin:0;">
        <ol class="custom-list grid mt-3">
            <li class="w-full">
                <div class="grid w-full">
                    <span class="md:col-4">Name of Procuring Agency:</span>
                    <span class="md:col-8 text-wrap word-break" style="border-bottom:#000 1px;">{{reportRecord?.nameOfProcuringAgency}}</span>
                </div>
            </li>
            <li class="w-full">
                <div class="grid w-full">
                    <span class="md:col-4">Method of Procurement:</span>
                    <span class="md:col-8" style="border-bottom:#000 1px;">{{reportRecord?.procurementMethod}}</span>
                </div>
            </li>
            <li class="w-full">
                <div class="grid w-full">
                    <span class="md:col-4">Title of Procurement:</span>
                    <span class="md:col-8 text-wrap word-break" style="border-bottom:#000 1px;">{{reportRecord?.procurementTitle}}</span>
                </div>
            </li>
            <!-- <li class="w-full">
                <div class="grid w-full">
                    <span class="md:col-4">Tender Inquiry No.:</span>
                    <span class="md:col-8 text-wrap word-break" style="border-bottom:#000 1px;">{{reportRecord?.tenderInquiryNo}}</span>
                </div>
            </li>
            <li class="w-full">
                <div class="grid w-full">
                    <span class="md:col-4">PPRA Ref. No. (TSE):</span>
                    <span class="md:col-8 text-wrap word-break" style="border-bottom:#000 1px;">{{reportRecord?.ppraRefNo}}</span>
                </div>
            </li> -->
            <li class="w-full">
                <div class="grid w-full">
                    <span class="md:col-4">Date & Time of Bid Closing:</span>
                    <span class="md:col-8 text-wrap word-break" style="border-bottom:#000 1px;">{{reportRecord?.closingDate}} {{ reportRecord?.closingTime }}</span>
                </div>
            </li>
            <li class="w-full">
                <div class="grid w-full">
                    <span class="md:col-4">Date & Time of Bid Opening:</span>
                    <span class="md:col-8 text-wrap word-break" style="border-bottom:#000 1px ;">{{reportRecord?.bidOpeningDate}} {{reportRecord?.bidOpeningTime }}</span>
                </div>
            </li>
            <li class="w-full">
                <div class="grid w-full">
                    <span class="md:col-4">No of Bids Received:</span>
                    <span class="md:col-8 text-wrap word-break" style="border-bottom:#000 1px;">{{reportRecord?.bidsReceived}}</span>
                </div>
            </li>
            <li class="w-full">
                <div class="grid w-full">
                    <span class="md:col-4">Criteria for Bid Evaluation:</span>
                    <span class="md:col-8 text-wrap word-break" style="border-bottom:#000 1px;">{{reportRecord?.criteriaBidEvaluation}}</span>
                </div>
            </li>
            <li class="w-full">
                <div class="grid w-full">
                    <span class="md:col-4">Details of Bid(s) Evaluation:</span>
                    <span class="md:col-8 text-wrap word-break" style="border-bottom:#000 1px;">{{reportRecord?.detailsBidEvaluation}}</span>
                </div>
            </li>
            <li class="w-full" *ngIf="!fromSupplier">
                <div class="grid w-full">
                    <span class="md:col-4">Evaluation Total Score:</span>
                    <span class="md:col-8 text-wrap word-break" style="border-bottom:#000 1px;">{{reportRecord?.totalEvaluationScore}}</span>
                </div>
            </li>

            <table aria-describedby="firstTable" style="margin: 20px 0px 20px -16px;">
                <tbody>
                    <tr>
                        <th scope="col" rowspan="2">Name of Bidder</th>
                        <th scope="col" colspan="3" *ngIf="FinalEvaluation">Marks</th>
                        <!-- <th rowspan="2" colspan="2">Technical & Financial</th> -->
                        <th scope="col" rowspan="2" *ngIf="FinalEvaluation">Evaluated Cost</th>
                        <th scope="col" rowspan="2">Schedule Items %</th>
                        <th scope="col" rowspan="2">Non-Schedule Items %</th>
                        <th scope="col" rowspan="2" >Rule/Regulation/SBD*/Policy/ Basis for Rejection / Acceptance</th>
                    </tr>
                    <tr *ngIf="FinalEvaluation">
                        <td><strong>Technical</strong><br><small>(if applicable)</small></td>
                        <td><strong>Financial</strong><br><small>(if applicable)</small></td>
                        <td><strong>Total Score</strong></td>
                    </tr>
                    <tr></tr>
                        <tr   *ngFor="let item of data">
                            <td>{{item?.nameOFBidder}}</td>
                            <!-- <td *ngIf="reportRecord?.procurementProcedure=='Single Stage Single Envelope'" colspan="2">{{item.marks}}</td> -->
                            <td class="text-wrap word-break" *ngIf="reportRecord?.procurementProcedure!='Single Stage Single Envelope'">{{item.technicalSectionMemberMarks}}</td>
                            <td class="text-wrap word-break" *ngIf="reportRecord?.procurementProcedure!='Single Stage Single Envelope  && FinalEvaluation'">{{item.financialSectionMemberMarks}}</td>
                            <td class="text-wrap word-break" *ngIf="reportRecord?.procurementProcedure=='Single Stage Single Envelope'"></td>
                            <td class="text-wrap word-break" *ngIf="reportRecord?.procurementProcedure=='Single Stage Single Envelope  && FinalEvaluation'">{{item.marks}}</td>
                            <td class="text-wrap word-break" >{{item.totalMarks}}</td>
                            <td class="text-wrap word-break" *ngIf="FinalEvaluation">{{item?.evaluatedCost | number}}</td>
                            <td class="text-wrap word-break" >{{item.scheduledItems}}</td>
                            <td class="text-wrap word-break" >{{item.nonScheduledItems}}</td>
                            <td class="text-wrap word-break">{{item?.loiResponse}} <label *ngIf="reportRecord?.itemWise">({{item.nameOFBidder}} found lowest for {{item.totalItems}} Items. Evaluated Cost = {{item.itemsCost}} PKR)</label> </td>
                        </tr>
                </tbody>
            </table>
            <div class="grid w-full mb-3" *ngIf="!reportRecord?.itemWise && FinalEvaluation===true">
                <strong class="md:col-4">Most Advantageous Bidder:</strong>
                <span class="md:col-8" style="border-bottom:#000 1px;">{{mostAdvantigiousBidder}}</span>
            </div>
            <li *ngIf="!reportRecord?.itemWise">
                <span>Any other additional / supporting information, the procuring agency may like to share.</span>
            </li>
        </ol>
    </div>
    <div class="breakhere" *ngIf="reportRecord?.itemWise">
            <h3 style="text-align: center;" *ngIf="isCenter"> <u> FINANCIAL COMPARATIVE STATEMENT </u></h3>
            <h3 *ngIf="!isCenter"> <u> FINANCIAL COMPARATIVE STATEMENT </u></h3>

            <table aria-describedby="secondTable">
            <thead>
                <tr>
                    <th scope="col">S.No</th>
                    <th scope="col">Item Name</th>
                    <th scope="col">Specification (if any)</th>
                    <th scope="col">Quantity</th>
                    <th scope="col">Evaluated Cost</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let item of itemwiseTableData;index as i">
                    <td>{{i+1}}</td>
                    <td>{{item.criterionTitle}}</td>
                    <td>{{item.specification}}</td>
                    <td>{{item.quantity}}</td>
                    <td>
                        <ol >
                            <li *ngFor="let supplierRecord of item.supplierData ;index as i">
                               {{supplierRecord.price}} <span *ngIf="i===0">(Most Advantageous) </span>{{supplierRecord.supplierName}}

                            </li>
                            <br>
                        </ol>
                    </td>
                </tr>
            </tbody>
        </table>
        <div>
            <h4>Lowest Evaluated Bidder</h4>
            <ol>
                <li *ngFor="let item of lowestBidderList">{{item.nameOFBidder}} found lowest for {{item.totalItems}} Items</li>
            </ol>
        </div>
    </div>
    <div>
        <strong >This is system Generated Report:</strong><br><br>
        <em><strong>*Standard Bidding Documents (SBD).</strong></em>
    </div>
</div>
